import {
  GetBuildingSearchResObj,
  GetBuildingSearchReqObj
} from '@gateway.Building'
import { yamadumiApi } from '../yamadumi-api'

/**
 * 物件情報一覧-明細部取得
 */
export class BuildingSearchGateway {
  static GetBuildingList = async (params: GetBuildingSearchReqObj) => {
    const req: GetBuildingSearchReqObj = {
      ...params,
      totalCostFrom: params.totalCostFrom !== null ? params.totalCostFrom * 1000000 : params.totalCostFrom,
      totalCostTo: params.totalCostTo !== null ? params.totalCostTo * 1000000 : params.totalCostTo,
      ourCompanyTotalCostFrom: params.ourCompanyTotalCostFrom !== null ? params.ourCompanyTotalCostFrom * 1000000 : params.ourCompanyTotalCostFrom,
      ourCompanyTotalCostTo: params.ourCompanyTotalCostTo !== null ? params.ourCompanyTotalCostTo * 1000000 : params.ourCompanyTotalCostTo
    }
    return await yamadumiApi.get<GetBuildingSearchResObj>('/api/building/list',
      { ...req }
    )
  }
}
